"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});
var e,
  t = require("styled-components"),
  o = (e = t) && "object" == typeof e && "default" in e ? e.default : e;
Object.keys(t).forEach(function (e) {
  "default" !== e && Object.defineProperty(exports, e, {
    enumerable: !0,
    get: function () {
      return t[e];
    }
  });
}), exports.DefaultTheme = {
  primary: "dodgerblue",
  colors: {
    primary: "dodgerblue",
    accent: "crimson"
  },
  alert: {
    radius: "12px",
    dark: {
      bg: "#334",
      text: "#9acdff"
    },
    light: {
      bg: "#fff",
      text: "dodgerblue"
    },
    info: {
      bg: "#9acdff",
      text: "#004c97"
    },
    success: {
      bg: "#a6ffa6",
      text: "#3b883b"
    },
    warning: {
      bg: "#ffe86e",
      text: "#7b6f2e"
    },
    danger: {
      bg: "#fdc0c0",
      text: "#ac0728"
    }
  },
  toggle: {
    inactive: "white",
    active: "dodgerblue",
    inside: "whitesmoke"
  },
  radio: {
    unchecked: "#eee",
    checked: "#705DF5",
    shadow: "rgba(0, 0, 0, .16)",
    pill: {
      hover: "#f8f8f8"
    }
  },
  card: {
    bgColor: "#fff",
    dividerColor: "whitesmoke"
  },
  font: {
    sans: "Avenir, Ubuntu, Segoe UI, -apple-system, sans-serif"
  },
  input: {
    bgColor: "whitesmoke"
  },
  check: {
    active: "#705DF5",
    borderColor: "#F0F0F9",
    activeTextColor: "#FFF",
    textColor: "#333333"
  },
  activity: {
    borderColor: "#848484",
    bgColor: "#fff",
    hoverColor: "whitesmoke"
  },
  skeleton: {
    from: "whitesmoke",
    to: "white"
  }
}, exports.default = o;